/**
 * Gives tables sorting capabilities by clicking their headers.
 *
 * Attribute directive used to decorate tables like this:
 * <table sortable-table st-initial-by="created_epoch_time" st-initial-reverse="true">
 * The initial-by is optional and decides which column to sort on initially (if any).
 * The initial-reverse is optional and decides if we want to start sorting in reverse order or not.
 *
 * Each table header is then decorated like this:
 * <th st-by="created_epoch_time">Date</th>
 * The st-by value should be the name of a property of the object that's ng-repeated inside the table.
 *
 * And finally the tr doing the ng-repeat should have the following orderBy clause:
 * <tr ng-repeat="item in model.items | orderBy:st.by:st.reverse">
 */
angular.module('hjApp').directive('sortableTable', [
    '$compile',
    '$parse',
    '$timeout',
    function ($compile, $parse, $timeout) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                var tableElement = $(element);

                scope.st = {
                    by: '',
                    reverse: false,
                    setSortColumn: function (by, defaultReverse = 'false') {
                        if (scope.st.by === by) {
                            scope.st.reverse = !scope.st.reverse;
                        } else {
                            scope.st.reverse = defaultReverse === 'true';
                        }
                        scope.st.by = by;
                    }
                };

                /**
                 * $timeout will cause this to execute after the current/next digest cycle.
                 * This allows for interpolated properties like st-by="{{ prop }}" to be populated
                 * with the correct string value. The correct approach is to refactor this and its
                 * usage to use a proper isolate scope and pass the properties in to the directive
                 */
                $timeout(init);

                function init() {
                    var tableId = tableElement.attr('id'),
                        thElements = tableElement.find('th[st-by]'),
                        onByChanged = $parse(attrs.stByChanged);

                    if (attrs.stInitialBy) {
                        scope.st.by = attrs.stInitialBy;
                    }
                    if (attrs.stInitialReverse) {
                        scope.st.reverse = attrs.stInitialReverse === 'true';
                    }

                    /**
                     * Since the clickable elements are the <a> tags we inject, pass down any clicks on the <th>
                     * element to its child <a> tag.
                     */
                    thElements.bind('click', function (event) {
                        var by = $(event.target).closest('[st-by]').attr('st-by');
                        var defaultReverse = $(event.target).closest('[st-by]').attr('st-default-reverse');
                        if (by) {
                            scope.st.setSortColumn(by, defaultReverse);
                        }

                        if (_.isFunction(onByChanged)) {
                            scope.$apply(onByChanged);
                        }
                    });

                    angular.forEach(thElements, function (thElement) {
                        var jqThElement = $(thElement),
                            by = jqThElement.attr('st-by'),
                            boundElement;

                        boundElement = $compile(
                            '<a id="' +
                                tableId +
                                '-st-by-' +
                                by +
                                '" ' +
                                'ng-class="{active: st.by === \'' +
                                by +
                                '\', reverse: st.reverse === false}" ' +
                                '>' +
                                jqThElement.html() +
                                '</a>' +
                                '<span ng-class="{' +
                                "'icon-xs': true," +
                                "'icon-caret-down': st.reverse," +
                                "'icon-caret-up': !st.reverse" +
                                '}" ' +
                                'ng-show="st.by === \'' +
                                by +
                                '\'"></span>'
                        )(scope);

                        jqThElement.html(boundElement);
                    });
                }
            }
        };
    }
]);
